import { Component, Input } from '@angular/core';
import { BUTTON_ANIM } from './mp-loading-button.animation';

@Component({
  selector: 'app-loading-button',
  templateUrl: './mp-loading-button.component.html',
  styleUrls: ['./mp-loading-button.component.scss'],
  animations: [BUTTON_ANIM],
})
export class MpLoadingButtonComponent {
  @Input()
  public disabled = false;

  @Input()
  public label: string;

  @Input()
  public icon: string;

  @Input()
  public loading = false;

  @Input()
  public customButtonClass: string;

  /**
   * Sizes are small, medium (default), big
   */
  @Input()
  public size = 'medium';

  /**
   * Colors are : primary (default), secondary, grey, primary-negative
   */
  @Input()
  public color = 'primary';

  @Input()
  public type = 'submit';

  isDisabled(): boolean {
    return this.disabled || this.loading;
  }
}
